<template>
    <div v-if="recommendations && !!recommendations.length" class="section-dimensioning section-dimensioning--small content-dimensioning">
        <base-section class="section-recommendations" :section="getRecommendationSection">
            <tiles-component
                :loading-tile="isLoadingNugget"
                :tiles="recommendations"
                :max-cols="Math.min(7, recommendations.length)"
            />
        </base-section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
    UITEXTS_FETCH_NS,
} from "@/store/actions.type";

import BaseSection from '@/components/sections/BaseSection.vue';
import TilesComponent from '@/components/TilesComponent.vue';

export default {
    name: 'RecommendationsComponent',
    components: {
        BaseSection,
        TilesComponent,
    },
    props: {

        recommendations: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapGetters('uitexts', {
            isLoadingUiTexts: 'isLoading',
            t: 't',
        }),

        ...mapGetters('nugget', {
            isLoadingNugget: 'isLoading',
        }),

        getRecommendationSection() {
            return {
                "type": "section-text-only",
                "introtext": {
                    "headline": this.t('recommended-content'),
                    "subline": null,
                    "copytext": null,
                    "button": null
                },
                "media": null,
                "component": null,
                "settings": {
                    "section": {
                        "foreground": "dark",
                        "backgroundColor": "",
                        "backgroundImage": null,
                        "textBehavior": "centered"
                    },
                    "layout": null,
                    "image": null,
                    "video": null,
                    "slideshow": null,
                    "accordion": null,
                    "abslider": null,
                    "thumbnails": null,
                    "choice": null
                }
            };
        }
    }
}
</script>
